import { withMediaAccessToken } from '../utils/mediaAccess';

/**
 * Normalize file URLs by replacing admin subdomain with main domain
 * Converts: https://admin.ketabavaran.com/storage/... 
 * To:       https://ketabavaran.com/storage/...
 */
export const normalizeFileUrl = (url) => {
  if (!url) return url;

  let normalized = url;

  // If it's a relative path, add the main domain
  if (typeof url === 'string' && url.startsWith('/')) {
    normalized = `https://ketabavaran.com${url}`;
  } else if (typeof url === 'string' && url.includes('admin.ketabavaran.com')) {
    // If it's a full URL, replace admin subdomain with main domain
    normalized = url.replace('admin.ketabavaran.com', 'ketabavaran.com');
  }

  return withMediaAccessToken(normalized);
};

/**
 * Normalize nested object with URL properties
 * Works recursively on objects and arrays
 */
export const normalizeNestedUrls = (data, urlFields = ['url', 'image', 'cover_url', 'avatar']) => {
  if (!data) return data;
  
  if (Array.isArray(data)) {
    return data.map(item => normalizeNestedUrls(item, urlFields));
  }
  
  if (typeof data === 'object') {
    const normalized = { ...data };
    
    // Normalize known URL fields
    urlFields.forEach(field => {
      if (field in normalized) {
        normalized[field] = normalizeFileUrl(normalized[field]);
      }
    });
    
    // Recursively normalize nested objects
    Object.keys(normalized).forEach(key => {
      if (typeof normalized[key] === 'object' && normalized[key] !== null) {
        normalized[key] = normalizeNestedUrls(normalized[key], urlFields);
      }
    });
    
    return normalized;
  }
  
  return data;
};
